import React, { useRef, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import waygomaps from 'waygo-maps';
import 'waygo-maps/dist/style.css';
import './MapsPage.css';


const MapsPage = () => {
    const {
        business_id,
        map_id,
        map_view_id,
        floor,
        query,
        content_placement_id,
        start_content_placement_id,
        end_content_placement_id,
        location,
        floor_location
    } = useParams();

    const locationn = useLocation();
    const isSetupMode = locationn.pathname.split('/').includes('setup');
    console.log("Current path:", locationn.pathname);
    console.log("Is setup mode:", isSetupMode);

    // const isSetupMode = window.location.pathname.includes('/setup');
    // console.log("IS SETUP MODE", isSetupMode);

    const [searchParams] = useSearchParams();
    const locationParamRef = useRef(searchParams.get('location'));
    

    const mapViewRef = useRef();
    const mapViewContainerRef = useRef();
    const mapDataRef = useRef(null);
    const navigate = useNavigate();

    const isProgrammaticNavigation = useRef(false);

    const businessIdRef = useRef(business_id);
    const mapIdRef = useRef(map_id);
    const mapViewIdRef = useRef(map_view_id);
    const floorRef = useRef(floor);
    const queryRef = useRef(query);
    const contentPlacementIdRef = useRef(content_placement_id);
    const startContentPlacementIdRef = useRef(start_content_placement_id);
    const endContentPlacementIdRef = useRef(end_content_placement_id);
    const locationRef = useRef(location);
    const floorLocationRef = useRef(floor_location);

    useEffect(() => {
        // console.log("UPDATING MAP VIEW", map_view_id);
        businessIdRef.current = business_id;
        mapIdRef.current = map_id;
        mapViewIdRef.current = map_view_id;
        floorRef.current = floor;
        queryRef.current = query;
        contentPlacementIdRef.current = content_placement_id;
        startContentPlacementIdRef.current = start_content_placement_id;
        endContentPlacementIdRef.current = end_content_placement_id;
        locationRef.current = location;
        floorLocationRef.current = floor_location;
        // console.log("UPDATING MAP VIEW END", floor_location);
    }, [business_id, map_id, map_view_id, floor, query, content_placement_id, start_content_placement_id, end_content_placement_id, location, floor_location]);
    

    useEffect(() => {
        if (isProgrammaticNavigation.current) {
            isProgrammaticNavigation.current = false;
            return;
        }

        if (mapViewRef.current) {
            if (floor) {
                mapViewRef.current.updateFloor(Number(floor), false);
            }


            // THIS IS NEW
            if (floor_location) {
                const floorString = floor_location.match(/^f(\d+)/);
                const floorNumber = floorString ? Number(floorString[1]) : null;
                if (floorNumber) {
                    mapViewRef.current.updateFloor(floorNumber, false);
                }

                if (floor_location.includes('@')) {
                    const [_, locationPart] = floor_location.split('@');
                    const [lng, lat, zoom, pitch, bearing] = locationPart.split(',').map(parseFloat);
                    mapViewRef.current.map.easeTo({
                        center: [lng, lat],
                        zoom: zoom,
                        pitch: pitch,
                        bearing: bearing,
                        // duration: 0
                    });
                }
            }

            if (query) {
                const decodedQuery = decodeURIComponent(query);
                mapViewRef.current.setToSearchState(decodedQuery);
            }
            else if (content_placement_id) {
                mapViewRef.current.setToSelectedContentState([content_placement_id]);
            } else if (start_content_placement_id || end_content_placement_id) {
                mapViewRef.current.setToDirectionsState(start_content_placement_id, end_content_placement_id);
            } else {
                mapViewRef.current.setToDefaultState();
            }
    
            // THIS IS OLD
            if (location) {
                const [lng, lat, zoom, pitch, bearing] = location.split(',').map(parseFloat);
                mapViewRef.current.map.easeTo({
                    center: [lng, lat],
                    zoom: zoom,
                    pitch: pitch,
                    bearing: bearing,
                    // duration: 0
                });
            }

            // console.log('floor_location', floor_location);

            
        }
    }, [business_id, map_id, map_view_id, floor, query, content_placement_id, start_content_placement_id, end_content_placement_id, floor_location]);

    const formatLocationString = (lng, lat, zoom, pitch, bearing) => {
        const roundedLng = Number(lng).toFixed(6);
        const roundedLat = Number(lat).toFixed(6);
        const roundedZoom = Number(zoom).toFixed(2);
        const roundedPitch = Number(pitch).toFixed(2);
        const roundedBearing = Number(bearing).toFixed(2);
        return `${roundedLng},${roundedLat},${roundedZoom},${roundedPitch},${roundedBearing}`;
    }

    const getLocation = () => {
        if (locationRef.current) {
            return locationRef.current;

        } else if (floorLocationRef.current && floorLocationRef.current.includes('@')) {
            const [_, locationPart] = floorLocationRef.current.split('@');
            const [lng, lat, zoom, pitch, bearing] = locationPart.split(',').map(parseFloat);
            return formatLocationString(lng, lat, zoom, pitch, bearing);

        } else {
            const currentCenter = mapViewRef.current.map.getCenter();
            const currentZoom = mapViewRef.current.map.getZoom();
            const currentPitch = mapViewRef.current.map.getPitch();
            const currentBearing = mapViewRef.current.map.getBearing();

            return formatLocationString(currentCenter.lng, currentCenter.lat, currentZoom, currentPitch, currentBearing);
        }


    };

    const updateFloorLocationURL = (floor, center, zoom, pitch, bearing) => {
        isProgrammaticNavigation.current = true;
        const currentFloor = floor || mapViewRef.current.getCurrentFloor();
        const currentCenter = center || mapViewRef.current.map.getCenter();
        const currentZoom = zoom || mapViewRef.current.map.getZoom();
        const currentPitch = pitch || mapViewRef.current.map.getPitch();
        const currentBearing = bearing || mapViewRef.current.map.getBearing();

        // const locationString = `${currentCenter.lng},${currentCenter.lat},${currentZoom},${currentPitch},${currentBearing}`;
        const locationString = formatLocationString(
            currentCenter.lng, 
            currentCenter.lat, 
            currentZoom, currentPitch, 
            currentBearing
        );
        
        const state = mapViewRef.current._stateCoordinator.state;

        if (state === 'search') {
            const encodedQuery = encodeURIComponent(queryRef.current);
            navigate(`/${mapIdRef.current}/${mapViewIdRef.current}/search/${encodedQuery}/f${currentFloor}@${locationString}`);
        } else if (state === 'selectedContent' && contentPlacementIdRef.current) {
            navigate(`/${mapIdRef.current}/${mapViewIdRef.current}/selected-content/${contentPlacementIdRef.current}/f${currentFloor}@${locationString}`);
        } else if (state === 'directions' && startContentPlacementIdRef.current && endContentPlacementIdRef.current) {
            navigate(`/${mapIdRef.current}/${mapViewIdRef.current}/directions/${startContentPlacementIdRef.current}/${endContentPlacementIdRef.current}/f${currentFloor}@${locationString}`);
        } else {
            navigate(`/${mapIdRef.current}/${mapViewIdRef.current}/f${currentFloor}@${locationString}`);
        }
    };

    // Function to update the URL based on the map's location and current state
    // const updateLocationURL = (zoom, pitch, bearing, center) => {
    //     isProgrammaticNavigation.current = true;
    //     const currentCenter = center || mapViewRef.current.map.getCenter();
    //     const currentZoom = zoom || mapViewRef.current.map.getZoom();
    //     const currentPitch = pitch || mapViewRef.current.map.getPitch();
    //     const currentBearing = bearing || mapViewRef.current.map.getBearing();
    //     const locationString = `${currentCenter.lng},${currentCenter.lat},${currentZoom},${currentPitch},${currentBearing}`;
    //     const state = mapViewRef.current._stateCoordinator.state;

    //     if (state === 'search') {
    //         navigate(`/${businessIdRef.current}/${mapIdRef.current}/${mapViewIdRef.current}/${floorRef.current}/search/${queryRef.current}/${locationString}`);
    //     } else if (state === 'selectedContent' && contentPlacementIdRef.current) {
    //         navigate(`/${businessIdRef.current}/${mapIdRef.current}/${mapViewIdRef.current}/${floorRef.current}/selected-content/${contentPlacementIdRef.current}/${locationString}`);
    //     } else if (state === 'directions' && startContentPlacementIdRef.current && endContentPlacementIdRef.current) {
    //         navigate(`/${businessIdRef.current}/${mapIdRef.current}/${mapViewIdRef.current}/${floorRef.current}/directions/${startContentPlacementIdRef.current}/${endContentPlacementIdRef.current}/${locationString}`);
    //     } else {
    //         navigate(`/${businessIdRef.current}/${mapIdRef.current}/${mapViewIdRef.current}/${floorRef.current}/${locationString}`);
    //     }
    // };
    //
    // const updateFloorURL = (floor) => {
    //     isProgrammaticNavigation.current = true;
    //     const currentCenter = mapViewRef.current.map.getCenter();
    //     const currentZoom = mapViewRef.current.map.getZoom();
    //     const currentPitch = mapViewRef.current.map.getPitch();
    //     const currentBearing = mapViewRef.current.map.getBearing();
    //     const locationString = `${currentCenter.lng},${currentCenter.lat},${currentZoom},${currentPitch},${currentBearing}`;
    //     const state = mapViewRef.current._stateCoordinator.state;

    //     if (state === 'search') {
    //         navigate(`/${businessIdRef.current}/${mapIdRef.current}/${mapViewIdRef.current}/${floor}/search/${queryRef.current}/${locationRef.current}`);
    //     } else if (state === 'selectedContent' && contentPlacementIdRef.current) {
    //         navigate(`/${businessIdRef.current}/${mapIdRef.current}/${mapViewIdRef.current}/${floor}/selected-content/${contentPlacementIdRef.current}/${locationRef.current}`);
    //     } else if (state === 'directions' && startContentPlacementIdRef.current && endContentPlacementIdRef.current) {
    //         navigate(`/${businessIdRef.current}/${mapIdRef.current}/${mapViewIdRef.current}/${floor}/directions/${startContentPlacementIdRef.current}/${endContentPlacementIdRef.current}/${locationRef.current}`);
    //     } else {
    //         navigate(`/${businessIdRef.current}/${mapIdRef.current}/${mapViewIdRef.current}/${floor}/${locationString}`);
    //     }
    // };

    // This useEffect block is to add accessToken and create the map view on load
    useEffect(() => {
        if (!mapViewContainerRef.current) {
            console.error("MapView container is not set");
            return;
        }
        waygomaps.setApiKey('3wUV12HDX-9wMWl99pXpwSYBP4XXdPe7gCm8E3FK_CI');

        const sourceId = map_view_id ? `${map_id}.${map_view_id}` : map_id;

        console.log("SETTING HERE", isSetupMode);

        // console.log("LOCATION PARAM:", locationParamRef.current);

        if (location) {
            const [lng, lat, zoom, pitch, bearing] = location.split(',').map(parseFloat);

            const locationOptions = {
                container: mapViewContainerRef.current.id,
                sourceId: sourceId,
                defaultControls: true,
                floor: Number(floor),
                center: [lng, lat],
                zoom: zoom,
                pitch: pitch,
                bearing: bearing,
                location: locationParamRef.current
            };

            if (isSetupMode) {
                locationOptions.setup = true;
            }

            mapViewRef.current = new waygomaps.MapView(locationOptions);
            
        } else if (floor_location) {
            // const floorString = floor_location.match(/^f(\d+)/);
            // const floorNumber = floorString ? Number(floorString[1]) : null;

            if (floor_location.includes('@')) {
                const [_, locationPart] = floor_location.split('@');
                const [lng, lat, zoom, pitch, bearing] = locationPart.split(',').map(parseFloat);

                const floorLocationOptions = {
                    container: mapViewContainerRef.current.id,
                    sourceId: sourceId,
                    defaultControls: true,
                    floor: Number(floor),
                    center: [lng, lat],
                    zoom: zoom,
                    pitch: pitch,
                    bearing: bearing,
                    location: locationParamRef.current
                }

                if (isSetupMode) {
                    floorLocationOptions.setup = true;
                }

                mapViewRef.current = new waygomaps.MapView(floorLocationOptions);
            } else {
                const floorLocationOptions = {
                    container: mapViewContainerRef.current.id,
                    sourceId: sourceId,
                    defaultControls: true,
                    floor: Number(floor),
                    location: locationParamRef.current
                }

                if (isSetupMode) {
                    floorLocationOptions.setup = true;
                }
                mapViewRef.current = new waygomaps.MapView(floorLocationOptions);
            }
        } else {
            // console.log("SETTING MAP VIEWWWWWWWW", mapViewRef.current);
            const mapViewOptions = {
                container: mapViewContainerRef.current.id,
                sourceId: sourceId,
                defaultControls: true,
                floor: Number(floor),
                location: locationParamRef.current
            }

            if (isSetupMode) {
                mapViewOptions.setup = true;
            }

            mapViewRef.current = new waygomaps.MapView(mapViewOptions);
        }

        // This adds all the controls to the MapView
        mapViewRef.current.on('load', (data) => {
            if (mapViewRef.current) {

                mapDataRef.current = data.mapData;

                // document.title = `Waygo Maps - ${data.map_name} (${data.map_view_name})`
                document.title = `${mapDataRef.current.map_name} - Waygo Maps`;


                // const currentParam = searchParams.get('current');
                // console.log("CURRENT PARAMM:", locationParamRef.current);


                if (!map_view_id) {
                    mapViewIdRef.current = data.mapData.map_view_id;
                    
                    // isProgrammaticNavigation.current = true;
                    const default_floor = data.mapData.default_floor;

                    setTimeout(() => {
                        if (mapViewRef.current) {
                            mapViewRef.current.updateFloor(default_floor, true);
                        }
                        // navigate(`/${map_id}/${mapViewIdRef.current}/f${default_floor}`);
                    }, 100);
                    // navigate(`/${map_id}/${mapViewIdRef.current}/f${default_floor}`);
                }

                if (floor_location) {
                    setTimeout(() => {
                        if (!mapViewRef.current) return;
                        
                        const floorString = floor_location.match(/^f(\d+)/);
                        let floorNumber = floorString ? Number(floorString[1]) : null;
                        
                        // if (floorNumber !== null) {
                        //     mapViewRef.current.updateFloor(floorNumber, true);
                        // } else {
                        //     mapViewRef.current.updateFloor(0, true);
                        // }

                        if (floorNumber === null) {
                            if (mapDataRef.current.default_floor) {
                                floorNumber = mapDataRef.current.default_floor;
                            } else {
                                floorNumber = 0;
                            }
                        }

                        if (floor_location.includes('@')) {
                            mapViewRef.current.updateFloor(floorNumber, false);
                        } else {
                            mapViewRef.current.updateFloor(floorNumber, true);
                        }
                        
                    }, 100);
                } else if (floor) {
                    // console.log("SETTING FLOOR???????????????:", floor);
                    mapViewRef.current.updateFloor(Number(floor), false);
                } else {
                    setTimeout(() => {
                        if (!mapViewRef.current) return;
                        const default_floor = data.mapData.default_floor;
                        mapViewRef.current.updateFloor(default_floor, true);
                    }, 100);
                }

                if (query) {
                    mapViewRef.current.setToSearchState(query);
                }
                else if (content_placement_id) {
                    mapViewRef.current.setToSelectedContentState([content_placement_id]);
                } else if (start_content_placement_id || end_content_placement_id) {
                    mapViewRef.current.setToDirectionsState(start_content_placement_id, end_content_placement_id);
                } else if (isSetupMode) {
                    mapViewRef.current.setToSetupState();
                } else {
                    console.log("SETTING DEFAULT STATE", isSetupMode);
                    if (!isSetupMode) {
                        console.log("SETTING DEFAULT STATE2");
                        mapViewRef.current.setToDefaultState();
                    }
                }
                mapViewRef.current.on('state:default', () => {
                    const updatedLocation = getLocation();
                    const currentFloor = mapViewRef.current.getCurrentFloor();
                    isProgrammaticNavigation.current = true;
                    document.title = `${mapDataRef.current.map_name} - Waygo Maps`;
                    navigate(`/${mapIdRef.current}/${mapViewIdRef.current}/f${currentFloor}@${updatedLocation}`);
                });

                mapViewRef.current.on('state:search', (data) => {
                    const { query: queryString } = data;
                    document.title = `${queryString} - ${mapDataRef.current.map_name} - Waygo Maps`;
                    isProgrammaticNavigation.current = true;
                    const currentFloor = mapViewRef.current.getCurrentFloor();
                    const encodedQuery = encodeURIComponent(queryString);
                    navigate(`/${mapIdRef.current}/${mapViewIdRef.current}/search/${encodedQuery}/f${currentFloor}@${locationRef.current}`);
                });

                mapViewRef.current.on('state:selectedContent', (data) => {
                    const { selectedContentPlacement } = data;
                    // console.log('selected');
                    // console.log(selectedContentPlacement);
                    const content_placement_id = selectedContentPlacement.placement_id;
                    // const titleKey = selectedContentPlacement.content.titleKey
                    const title = selectedContentPlacement.content.data[selectedContentPlacement.catalog.content_title_key];
                    document.title = `${title} - ${mapDataRef.current.map_name} - Waygo Maps`;
                    const updatedLocation = getLocation();
                    const currentFloor = mapViewRef.current.getCurrentFloor();
                    isProgrammaticNavigation.current = true;
                    navigate(`/${map_id}/${mapViewIdRef.current}/selected-content/${content_placement_id}/${currentFloor}@${updatedLocation}`);
                });

                mapViewRef.current.on('state:directions', (data) => {
                    const { startContentPlacement, endContentPlacement } = data;
                    let startContentPlacementId = ",";
                    if (startContentPlacement) {
                        startContentPlacementId = startContentPlacement.placement_id;
                    }

                    let endContentPlacementId = ",";
                    if (endContentPlacement) {
                        endContentPlacementId = endContentPlacement.placement_id;
                    }
                    const updatedLocation = getLocation();
                    isProgrammaticNavigation.current = true;
                    const currentFloor = mapViewRef.current.getCurrentFloor();
                    document.title = `Directions - ${mapDataRef.current.map_name} - Waygo Maps`;
                    navigate(`/${map_id}/${mapViewIdRef.current}/directions/${startContentPlacementId}/${endContentPlacementId}/${currentFloor}@${updatedLocation}`);
                });

                mapViewRef.current.on('state:setup', () => {
                    console.log("STATE SETUP");
                });

                mapViewRef.current.on('zoomend', () => {
                    const zoom = mapViewRef.current.map.getZoom();
                    // updateLocationURL(zoom);
                    updateFloorLocationURL(null, null, zoom);
                });

                mapViewRef.current.on('pitchend', () => {
                    const pitch = mapViewRef.current.map.getPitch();
                    // updateLocationURL(null, pitch);
                    updateFloorLocationURL(null, null, null, pitch);
                });

                mapViewRef.current.on('rotateend', () => {
                    const bearing = mapViewRef.current.map.getBearing();
                    // updateLocationURL(null, null, bearing);
                    updateFloorLocationURL(null, null, null, null, bearing);
                });

                mapViewRef.current.on('moveend', () => {
                    const center = mapViewRef.current.map.getCenter();
                    // updateLocationURL(null, null, null, center);
                    updateFloorLocationURL(null, center);
                });

                mapViewRef.current.on('floorChanged', (data) => {
                    const { floorIndex } = data
                    // updateFloorURL(floorIndex);
                    updateFloorLocationURL(floorIndex);
                });
            }
        });

        return () => {
            if (mapViewRef.current && mapViewRef.current.parentNode) {
                mapViewRef.current.parentNode.removeChild(mapViewRef.current);
            }
        };
    }, []);

    return (
        <>
            <div id="map-container" ref={mapViewContainerRef} />
        </>
    );
};

export default MapsPage;